import { render, staticRenderFns } from "./GhostReservation.vue?vue&type=template&id=33c002ff&scoped=true"
import script from "./GhostReservation.vue?vue&type=script&lang=js"
export * from "./GhostReservation.vue?vue&type=script&lang=js"
import style0 from "./GhostReservation.vue?vue&type=style&index=0&id=33c002ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c002ff",
  null
  
)

export default component.exports